/**
 * Stable PayPal payment link. Do not paste a checkout session URL
 * (flowlogging_id / openButton): it expires.
 */
export const SUPPORT_URL = 'https://www.paypal.com/ncp/payment/R5PP2PY5KHEMW'
